import PageLayout from "./getinvolve/PageLayout ";

export default function PrivacyPolicy() {
  return (
    <PageLayout
      title="Privacy Policy"
      desc="Your privacy is important to us. Learn how we collect, use, and protect your information."
    >
      <div className="advocacy-content">
        <p>
          At ICSAJ (International Council of Sanatan Advocacy & Justice), we are
          committed to protecting the privacy and personal information of our
          users, members, and visitors. This Privacy Policy outlines how we
          collect, use, store, and safeguard your information when you interact
          with our website and services.
        </p>

        <p>
          By accessing or using our platform, you agree to the terms outlined in
          this policy. We encourage users to read this document carefully to
          understand our practices regarding personal data and privacy.
        </p>

        <h4 className="mt-4">Information We Collect</h4>
        <p>
          We may collect personal information such as your name, email address,
          phone number, and any other details you voluntarily provide through
          forms, registrations, or communications. Additionally, we may collect
          non-personal information such as browser type, IP address, and usage
          data to improve our services.
        </p>

        <h4 className="mt-4">How We Use Your Information</h4>
        <ul className="advocacy-list">
          <li>To provide and improve our services</li>
          <li>To respond to inquiries and support requests</li>
          <li>To process applications, reports, or collaborations</li>
          <li>To send important updates and notifications</li>
          <li>To ensure security and prevent misuse</li>
        </ul>

        <p>
          We ensure that your information is used only for lawful purposes and
          in a manner that respects your privacy and rights.
        </p>

        <h4 className="mt-4">Data Protection & Security</h4>
        <p>
          We implement appropriate technical and organizational measures to
          protect your personal data from unauthorized access, disclosure,
          alteration, or destruction. While we strive to use commercially
          acceptable means to protect your information, no method of
          transmission over the internet is completely secure.
        </p>

        <h4 className="mt-4">Sharing of Information</h4>
        <p>
          ICSAJ does not sell, trade, or rent users' personal information to
          third parties. We may share information only when required by law,
          legal processes, or to protect our legal rights and ensure compliance
          with applicable regulations.
        </p>

        <h4 className="mt-4">Cookies & Tracking</h4>
        <p>
          Our website may use cookies and similar technologies to enhance user
          experience, analyze traffic, and understand user behavior. You can
          choose to disable cookies through your browser settings; however, this
          may affect certain functionalities of the website.
        </p>

        <h4 className="mt-4">User Rights</h4>
        <p>
          You have the right to access, update, or request deletion of your
          personal data. If you wish to exercise these rights, you may contact
          us through the provided communication channels.
        </p>

        <h4 className="mt-4">Third-Party Links</h4>
        <p>
          Our website may contain links to external websites. We are not
          responsible for the privacy practices or content of such third-party
          sites. Users are advised to review the privacy policies of those
          websites separately.
        </p>

        <h4 className="mt-4">Changes to This Policy</h4>
        <p>
          ICSAJ reserves the right to update or modify this Privacy Policy at
          any time. Any changes will be reflected on this page, and continued
          use of the website will constitute acceptance of those changes.
        </p>

        <h4 className="mt-4">Contact Us</h4>
        <p>
          If you have any questions or concerns regarding this Privacy Policy or
          how your data is handled, you may contact us through our official
          website or support channels.
        </p>
      </div>
    </PageLayout>
  );
}
